import React from 'react'

function UseIncreament() {

   const Increament = async(token:string,url:string,id:number | string,price:string)=>{
    const productPrice =parseInt(price,10)
    try{
        const response = await fetch(url,{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({
            token:token,
            product:id,
            price:productPrice
        })
    })


    if(response.ok){
        const jsonData = await response.json()
        console.log(jsonData)

    }else{
        const jsonData = await response.json()
        console.log(jsonData)
    }
    }catch(error:any){
        console.log(error.message)

    }
      

   }

   const Decreament = async(token:string,url:string,id:number | string,price:string)=>{
    const productPrice =parseInt(price,10)
    try{
        const response = await fetch(url,{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({
            token:token,
            product:id,
            price:productPrice
        })
    })


    if(response.ok){
        const jsonData = await response.json()
        console.log(jsonData)

    }else{
        const jsonData = await response.json()
        console.log(jsonData)
    }
    }catch(error:any){
        console.log(error.message)

    }
      

   }



  return {Increament,Decreament}
}

export default UseIncreament
